import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HealthService } from '@app/services/health/health.service';
import { Promoter } from '@app/_models/health';
import { FormBuilder, Validators } from '@angular/forms';
import Utilities from '@app/_helpers/utilities';
@Component({
  selector: 'health-add-promoter',
  templateUrl: './health-add-promoter.component.html',
  styleUrls: ['./health-add-promoter.component.scss'],
})
export class HealthAddPromoterComponent implements OnInit {
  constructor(
    private _healthService: HealthService,
    private _builder: FormBuilder
  ) { }
  @Output() onAddedPromoters = new EventEmitter<Promoter[]>();
  @Output() onClosedDialog = new EventEmitter<boolean>();
  newPromoterImgReview: string;
  promoters: Promoter[] = [];
  selectedPromoters: Promoter[] = [];
  isCreatingNewPromoter = false;
  newPromoterForm = this._builder.group({
    name: ['', Validators.required],
    image: ['', Validators.required],
  });

  ngOnInit() {
    this._healthService.getPromoters().subscribe(promoters => {
      this.promoters = promoters;
    });
  }

  addPromoters() {
    this.onAddedPromoters.emit(this.selectedPromoters);
  }

  selectPromoter(sponsor: Promoter, target: Element) {
    if (target.classList.contains('active')) {
      target.classList.remove('active');
      this.selectedPromoters = this.selectedPromoters.filter(e => {
        e.id !== sponsor.id;
      });
    } else {
      target.classList.add('active');
      this.selectedPromoters.push(sponsor);
    }
  }

  uploadNewPromoterImg() {
    document.getElementById('fileInput').click();
  }

  resetForm() {
    this.newPromoterForm.reset();
    this.isCreatingNewPromoter = false;
    this.newPromoterImgReview = '';
  }

  saveNewPromoter() {
    const promoter: FormData = new FormData();
    promoter.append('name', this.newPromoterForm.get('name').value);
    promoter.append('image', this.newPromoterForm.get('image').value);
    this._healthService.createPromoter(promoter).subscribe((newPromoter) => {
      this.promoters.push(newPromoter);
      this.resetForm();
    });
  }

  async handleFileInput(file: File): Promise<string> {
    this.newPromoterForm.patchValue({
      image: file,
    });
    this.newPromoterImgReview = await Utilities.toBase64(file);
    return '';
  }
}
